import React from "react";
import type { UseFormRegister, FieldErrors } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import type { BusinessProfileFormData } from "@/types/business-profile";

interface AddressSectionProps {
  register: UseFormRegister<BusinessProfileFormData>;
  errors: FieldErrors<BusinessProfileFormData>;
  isSubmitting: boolean;
  loading: boolean;
}

export const AddressSection: React.FC<AddressSectionProps> = ({
  register,
  errors,
  isSubmitting,
  loading,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground">
        Address
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="line1">Address Line 1</Label>
          <Input
            id="line1"
            placeholder="123 Main Street"
            {...register("contact_info.address.line1")}
            error={errors.contact_info?.address?.line1?.message}
            disabled={isSubmitting || loading}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="line2">Address Line 2 (Optional)</Label>
          <Input
            id="line2"
            placeholder="Apt 4B"
            {...register("contact_info.address.line2")}
            error={errors.contact_info?.address?.line2?.message}
            disabled={isSubmitting || loading}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label htmlFor="city">City</Label>
          <Input
            id="city"
            placeholder="New York"
            {...register("contact_info.address.city")}
            error={errors.contact_info?.address?.city?.message}
            disabled={isSubmitting || loading}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="state">State</Label>
          <Input
            id="state"
            placeholder="NY"
            {...register("contact_info.address.state")}
            error={errors.contact_info?.address?.state?.message}
            disabled={isSubmitting || loading}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="postal_code">Postal Code</Label>
          <Input
            id="postal_code"
            placeholder="10001"
            {...register("contact_info.address.postal_code")}
            error={errors.contact_info?.address?.postal_code?.message}
            disabled={isSubmitting || loading}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="country">Country</Label>
          <Input
            id="country"
            placeholder="United States"
            {...register("contact_info.address.country")}
            error={errors.contact_info?.address?.country?.message}
            disabled={isSubmitting || loading}
          />
        </div>
      </div>
    </div>
  );
};